import VueRouter from "vue-router";
import { store } from "store";
VueRouter.prototype.clearHistory = function () {
    if (this.history.stack) {
        this.history.stack = this.history.current ? [this.history.current] : [];
        this.history.index = this.history.current ? 0 : -1;
    }
};
function hasRouted(vue) {
    return (typeof vue["routed"] == "function");
}
function callRouted(vue) {
    if (hasRouted(vue))
        vue["routed"](vue.$route.params, vue.$route.query);
}
// function popup(title, description){
//     store.popup.title = title;
//     store.popup.description = description;
//     store.popup.visible = true;
// }
export default {
    created: function () {
        var _this = this;
        if (hasRouted(this)) {
            callRouted(this);
            this.$watch("$route", function () { return callRouted(_this); });
        }
        window.scrollTo(null, 0);
    },
    computed: {
        root: function () { return this.$root; },
    },
    methods: {
        $reload: function () {
            this.$resetData();
            callRouted(this);
        },
        $resetData: function () {
            Object.assign(this.$data, (typeof this.$options.data == "function")
                ? this.$options.data.apply(this)
                : this.$options);
        },
        $popup: function (title, description) {
            store.popup.title = title;
            store.popup.description = description;
            store.popup.visible = true;
        },
    },
    filters: {
        truncate: function (text, maxLength) {
            if (!text)
                return "";
            if (maxLength < 3)
                maxLength = 3;
            if (text.length > maxLength)
                text = text.substring(0, maxLength) + "...";
            return text;
        }
    },
};



//////////////////
// WEBPACK FOOTER
// ./app/ts/vue-mixins.ts
// module id = 80
// module chunks = 0